const COMMON = {

  // 地図の著作権表示
  attribution: '© ONE COMPATH © GeoTechnologies Inc.',

  mapionLogoAlt: '地図検索マップ マピオン',

  // モバイル判定のwidth閾値
  mobileBreakpoint: 600,
  // タブレット判定のwidth閾値
  tabletBreakpoint: 768,

  // 距離で使用する単位
  unit: {
    meter: 'm',
    kilometer: 'km'
  },
  // 単位変換閾値
  conversions: {
    metersPerKm: 1000,
  },

  // DOMタグ
  domTags: {
    anchor: 'a',
    canvas: 'canvas',
    div: 'div',
    script: 'script',
  },

  // キーボード
  keyNames: {
    escape: 'Escape',
    slash: 'Slash',
  },
};

export default COMMON;
